var filterHoverValueWrapper = document.querySelector('#filter-hover-label')
var selectedFilterItem = document.querySelector('#result-filter .remove-filter')
var selectedFilterValue = null



document.addEventListener('DOMContentLoaded', ()=>{
    selectedFilterItem.addEventListener('click', ()=>{
        selectedFilterItem.classList.add('hide')
    })
    const updateColorFilter = async (value) => {
        const filterUrl = `filter.v.price.gte=&filter.v.price.lte=&filter.p.m.custom.filter=${value}&sort_by=manual`
        selectedFilterValue = value
        
        FacetFiltersForm.renderPage(filterUrl, null, false)
        
    }
    document.querySelectorAll('.ccfs-item_filter').forEach(button => {
        button.addEventListener('click', function(){
            filterHoverValueWrapper.innerHTML = ""
            if(selectedFilterItem){
                selectedFilterItem.classList.remove('hide')
                selectedFilterItem.setAttribute('data-active-filter-value',button.dataset.filterValue)
                selectedFilterItem.querySelector('span').innerHTML = button.dataset.filterValue
                updateColorFilter(button.dataset.filterLabel)
            }
        })

        if(filterHoverValueWrapper) {
            button.addEventListener('mouseover', () => {
                filterHoverValueWrapper.innerHTML = button.dataset.filterValue
            })
            button.addEventListener('mouseleave', () => {
                filterHoverValueWrapper.innerHTML = ''
            })
        }
        
    })

    function insertImg(){
        document.querySelectorAll('.ccfs-item_filter').forEach(item => {
            var itemVal = item.dataset.filterValue;
            document.querySelectorAll('.filter-img-code').forEach(imgItem => {
                var colorName = imgItem.dataset.colorName;
                var imgUrl = imgItem.dataset.imgUrl;
                if(itemVal == colorName){
                    item.querySelector('img').src = imgUrl;
                }
            })
        })
    } 
    insertImg();
    
})